<script>
import {mapActions} from "vuex";
import Card from "@/components/forms/Card.vue";
import {VueDraggableNext} from "vue-draggable-next";
import {AppApi} from "@/api/AppApi";
import {showSystemNoti} from "@/shared/helper";

export default {
  name: "ExploreMenuConfig",
  components: {draggable : VueDraggableNext, Card},
  data()
  {
    return{
      menus : [],
      pageLoad : true
    }
  },
  mounted()
  {
    this.setPageLoading(false);
    this.setPageTitle('منوهای بخش اکسپلور');
    this.setShowHead(true);
    this.getPageItems();
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
    addNewMenu()
    {
      this.menus.push({link : '',title : ''})
    },
    deleteMenu(index)
    {
      this.menus.splice(index,1)
    },
    async submitMenus()
    {
      this.setPageLoading(true);
      const result = await AppApi.submitExploreMenus({menus : this.menus});
      if (result.ok)
        showSystemNoti('success',result.message);
      else
        showSystemNoti('danger',result.error);
      this.setPageLoading(false);
    },
    async getPageItems()
    {
      this.setPageLoading(true);
      const result = await AppApi.getExploreMenus();
      if (result.ok)
      {
        this.menus = result.menus;
      }
      this.setPageLoading(false);
    }
  }
}
</script>

<template>
  <Card v-if="pageLoad">
    <button class="btn btn-info mb-2" @click="addNewMenu">افزودن آیتم&nbsp;<i class="far fa-plus"></i></button>
    <draggable v-if="menus"  class="page-items " :list="menus" @change="">
      <div class="drag-item " v-for="(item ,index) in menus" :key="item">
        <div class="item">
          <input v-model="item.title" class="form-control " name="title" placeholder="عنوان منو">
        </div>
        <div class="item">
          <input v-model="item.link" class="form-control item" name="link" placeholder="لینک منو">
        </div>
        <div class="align-self-center">
          <button @click="deleteMenu(index)" class="btn btn-danger btn-sm"><i class="far fa-trash-can"></i></button>
        </div>
      </div>
    </draggable>
    <div class="row">
      <div class="col-8 col-md-5 mx-auto">
        <button @click="submitMenus" class="btn btn-info btn-block mt-3">ثبت اطلاعات</button>
      </div>
    </div>
  </Card>
</template>

<style scoped>
.drag-item {
  display: flex;
  grid-gap: 5px;
  flex-direction: row;
  padding: 5px;
  cursor: pointer;
  margin-bottom: 10px;
  box-shadow: 0 0 3px 1px #0003;
  border-radius: 10px;
}
.drag-item .item
{
  flex: 1;
}
</style>